<template>
    <div>
        <v-breadcrumbs :items="breadcrumbs">
        <template v-slot:divider>
            <v-icon icon="mdi-chevron-right"></v-icon>
        </template>
        <template v-slot:title="{ item }">
            <div v-html="item.title"></div>
        </template>
        </v-breadcrumbs>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import opmStore from '@/lib/storeOwnerProjectManager';
const breadcrumbs = computed(() => {
    const breadCrumbArray = opmStore.getters.getBreadcrumbs;
    breadCrumbArray.forEach((item) => {
        if(item?.entityTypeTitle){
            item.title = `<span class='entity-type'>${item.entityTypeTitle}</span>${item.title}`;
        }
    });
    return breadCrumbArray;
})


</script>
<style>
.v-breadcrumbs {
font-size: 13px;
}
.v-breadcrumbs-item {
position: relative;
line-height: 1.25;
}
.v-breadcrumbs-item:hover span.entity-type,
.v-breadcrumbs-item:focus span.entity-type{
opacity: 1;
top: -.85rem;
}
span.entity-type{
font-size: 10px !important;
text-transform: capitalize;
position: absolute;
top: 0;
left: .25rem;
opacity: 0;
transition: all 0.3s ease;
white-space: nowrap;
}
.v-breadcrumbs-item--disabled {
cursor: default;
pointer-events:all;
}
</style>
